import { memo } from 'react';

import { type AssetCustomFieldValue } from '@air/api/types';

import { PanelCustomFieldContainer, type PanelCustomFieldContainerProps } from './PanelCustomFieldContainer';

export type PublicAssetPanelCustomFieldContainerProps = Omit<
  PanelCustomFieldContainerProps<AssetCustomFieldValue>,
  'canDeleteCustomFields' | 'canEditCustomFields' | 'onClick'
>;

export const PublicAssetPanelCustomFieldContainer = memo((params: PublicAssetPanelCustomFieldContainerProps) => {
  return <PanelCustomFieldContainer canDeleteCustomFields={false} canEditCustomFields={false} {...params} />;
});

PublicAssetPanelCustomFieldContainer.displayName = 'PublicAssetPanelCustomFieldContainer';
